import { ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';
import { Editor, EditorEvent } from 'tinymce';
import { stopEvent } from '@shared/utils/elements-util';
import { BaseFrameEditorComponent } from '../base-frame-editor/base-frame-editor.component';
import { FrameEditorConstants } from '../../constants/frame-editor.constants';
import { UntilDestroy } from '@ngneat/until-destroy';
import { isCtrlOrCommandCombination, keyCodes, KeyName } from '@local/ts-infra';
import { EditorComponent } from '@tinymce/tinymce-angular';

@UntilDestroy()
@Component({
  selector: 'readonly-frame-editor',
  templateUrl: './readonly-frame-editor.component.html',
  styleUrls: ['../base-frame-editor/base-frame-editor.scss', './readonly-frame-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReadonlyFrameEditorComponent extends BaseFrameEditorComponent {
  @ViewChild('editor') editor: EditorComponent;
  @ViewChild('editorContainer') editorContainer: ElementRef;
  protected readonlyFrame = true;

  setEditorInit(): any {
    return {
      ...this.frameEditorService.getEditorInit(),
      plugins: FrameEditorConstants.READONLY_PLUGINS,
      body_class: `${this.bodyClass} view-mode`,
      toolbar: false,
      object_resizing: false,
      quickbars_selection_toolbar: false,
      content_style: FrameEditorConstants.CONTENT_STYLE_VIEW,
      contextmenu: FrameEditorConstants.CONTEXTMENU_VIEW,
      setup: (editor: Editor) => {
        this.setSetupEditorInit(editor);
      },
    };
  }

  setSetupEditorInit(editor: Editor) {
    this.frameEditorService.addContextMenuButtons(true, this.id);
    this.addKeyboardToEditor(editor);
    this.addLinkListenersToEditor(editor);
    editor.on('init', () => {
      //HACK: enable text selection and copying for code blocks in published mode
      const preElements = editor.getBody().querySelectorAll('pre');
      preElements?.forEach((pre) => {
        pre.removeAttribute('contenteditable');
      });

      this.handleInitEditor(editor);
    });
    editor.on('paste', (event) => {
      stopEvent(event);
    });
    editor.on('drop', (event) => {
      stopEvent(event);
    });
    editor.on('drag', (event) => {
      stopEvent(event);
    });
  }

  handleKeys(event: EditorEvent<KeyboardEvent>) {
    if (!isCtrlOrCommandCombination(event, keyCodes.c as KeyName)) {
      stopEvent(event);
    }
  }
}
